import { Component, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { SeoServiceService } from 'src/app/services/seo-service.service';

@Component({
    selector: 'app-projector-vs-interactive-flat-panel',
    templateUrl: './projector-vs-interactive-flat-panel.component.html',
    styleUrls: ['./projector-vs-interactive-flat-panel.component.scss']
})
export class ProjectorVsInteractiveFlatPanelComponent implements OnInit {

    constructor(
        private titleService: Title,
        private metaService: Meta,
        private seoService: SeoServiceService
    ) { }

    ngOnInit(): void {
        this.seoService.createLinkForCanonicalURL();
        this.titleService.setTitle('Projector vs Interactive Flat Panel: What Schools Should Choose in 2026 | Virsa');
        this.metaService.updateTag({ name: 'description', content: 'Compare projectors vs interactive flat panels for schools. Discover which is better for smart classrooms, digital learning, and long-term performance with Virsa solutions.' });
        this.metaService.updateTag({ name: 'keywords', content: 'Projector vs interactive flat panel, Interactive flat panel for schools, Smart classroom display comparison, Digital classroom solutions India, Best display for classrooms, Projector vs smart board, IFP vs projector benefits, Smart classroom technology, Interactive display advantages, Virsa interactive flat panels' });
    }

}
